import { palette } from '@app/palette';
import { Box, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
interface SurveyTitleProps {
  title: string | undefined;
}
export const SurveyTitle: FC<SurveyTitleProps> = ({ title }) => {
  return (
    <Box display={'flex'} sx={{ backgroundColor: palette.primary.light }} component={'div'} padding={1}>
      <Grid container display={'flex'} justifyContent={'center'} flexDirection={'row'}>
        <Grid>
          <Typography color={palette.secondary.contrastText} variant={'h4'}>
            {title}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
